import { BooleanOperator, QueryBuilderSubquery } from '@ardoq/api-types';
import {
  isPureTypeEqualitySubquery,
  isTypeEqualityQueryBuilderRule,
} from '@ardoq/filter-helpers';

export type PerspectiveResult = {
  id: string;
  name: string;
  isSelected: boolean;
  isCurrentlyModified: boolean;
};

/**
 * Refer to js doc for `findQuickPerspectivesTypeEqualitySubquery`
 */
export const clearQucikPerspectiveTypeFilters = (
  ruleRoot: QueryBuilderSubquery
) => {
  const isQickPerspectivesTypeFilter =
    ruleRoot.condition === BooleanOperator.OR
      ? isTypeEqualityQueryBuilderRule
      : isPureTypeEqualitySubquery;

  const newRules = ruleRoot.rules.filter(
    rule => !isQickPerspectivesTypeFilter(rule)
  );

  return {
    ...ruleRoot,
    rules: newRules,
  };
};
